// src/components/LoadingLottie.tsx

import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

/**
 * Componente de carga usando DotLottieReact.
 */
const LoadingLottie: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      minHeight: '200px',
    }}>
      <DotLottieReact
        src="https://lottie.host/14834f98-514e-415c-bbf4-1c13763e0249/zXWLV0H9Co.lottie"
        loop
        autoplay
        style={{ width: '100px', height: '100px' }}
      />
    </div>
  );
};

export default LoadingLottie;
